export class Holydays {

    constructor(
        public user_id: number = null,
        public rep_id: number = null,
        public id: number = null,
        public timeOffStartDate: string = '',
        public hrTimeOffStartDate: string = '08:00',
        public returnToWorkDate: string = '',
        public hrReturnToWorkDate: string = '08:00',
        public typeOfLeave: string = '',
        public reasonforLeave: string = '',
        public employeeSignature: string = null,
        public employeeSignatureDate: number = null,
        public approvals: string = '0',
        public reasonforDenyingRequest: string = '',
        public supervisorSignature: string = null,
        public supervisorSignatureDate: number = null,
        public name: string = '',
        public email: string = '',
        public sup_id: number = null,
        public revised: number = 0,
        public absence: string = ''
    ) {}
}